import React from 'react';

import {VIDEO_EMBED_URL} from '../gettingStartedResources';

interface Props {
  className?: string;
}

/** The "How to get started on Albert" YouTube embed, shared by the Welcome card and Helpful Links rail. */
export const GettingStartedVideo = ({className = ''}: Props) => (
  <iframe
    allowFullScreen
    className={`rounded-x1 aspect-[16/9] w-full border-none ${className}`}
    src={VIDEO_EMBED_URL}
    title='Getting started with Albert'
  />
);
